import React, { useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const Paginator = ({fetchRecords, currentPage, pages}) => {
  return (
    <Stack spacing={2}>
      <Pagination showFirstButton showLastButton count={pages} page={currentPage + 1} onChange={fetchRecords} variant="outlined" />
    </Stack>
  )
}

export default Paginator